import { dayjs } from '@shared/utils';
import { z } from 'zod';

import { MONTH_ORDER } from '../../constants';
import { ExamCourseType } from '../../types';

const MIN_ARRAY_LENGTH = 1;

export const ExamCourseAnalysisReportFilterSchema = z
  .object({
    startMonth: z
      .object(
        {
          label: z.string(),
          value: z.enum(MONTH_ORDER),
        },
        { message: 'กรุณาเลือก Month' },
      )
      .nullable()
      .refine((val) => !!val, { message: 'กรุณาเลือก Month' }),
    startYear: z
      .object(
        {
          value: z.number(),
          label: z.string(),
        },
        {
          message: 'กรุณาเลือก Year',
        },
      )
      .nullable()
      .refine((val) => !!val, { message: 'กรุณาเลือก Year' }),
    endMonth: z
      .object(
        {
          label: z.string(),
          value: z.enum(MONTH_ORDER),
        },
        { message: 'กรุณาเลือก Month' },
      )
      .nullable()
      .refine((val) => !!val, { message: 'กรุณาเลือก Month' }),
    endYear: z
      .object(
        {
          value: z.number(),
          label: z.string(),
        },
        {
          message: 'กรุณาเลือก Year',
        },
      )
      .nullable()
      .refine((val) => !!val, { message: 'กรุณาเลือก Year' }),
    examCenter: z
      .array(
        z.object(
          {
            value: z.string(),
            label: z.string(),
          },
          { message: 'กรุณาเลือก Exam Center' },
        ),
      )
      .min(MIN_ARRAY_LENGTH, { message: 'กรุณาเลือก Exam Center' }),
    courseType: z
      .array(
        z.object(
          {
            value: z.nativeEnum(ExamCourseType),
            label: z.string(),
          },
          { message: 'กรุณาเลือก Exam Course' },
        ),
      )
      .min(MIN_ARRAY_LENGTH, { message: 'กรุณาเลือก Exam Course' }),
    examCourse: z
      .array(
        z.object(
          {
            value: z.string(),
            label: z.string(),
          },
          { message: 'กรุณาเลือก Exam Course' },
        ),
      )
      .min(MIN_ARRAY_LENGTH, { message: 'กรุณาเลือก Exam Course' }),
    qConfigRef: z
      .array(
        z.object({
          value: z.string(),
          label: z.string(),
        }),
        { message: 'กรุณาเลือก QConfig Ref.' },
      )
      .min(MIN_ARRAY_LENGTH, { message: 'กรุณาเลือก QConfig Ref.' }),
  })
  .refine(
    (data) => {
      if (!data.startMonth || !data.endMonth) {
        return true; // Let individual field validation handle this
      }

      const startDate = dayjs()
        .set('month', MONTH_ORDER.indexOf(data.startMonth.value))
        .set('year', data.startYear.value);
      const endDate = dayjs()
        .set('month', MONTH_ORDER.indexOf(data.endMonth.value))
        .set('year', data.endYear.value);

      return endDate.isSameOrAfter(startDate);
    },
    {
      message: 'End Month ต้องมากกว่าหรือเท่ากับ Start Month',
      path: ['endMonth'],
    },
  );

export type ExamCourseAnalysisReportFilterFormInput = z.input<
  typeof ExamCourseAnalysisReportFilterSchema
>;
export type ExamCourseAnalysisReportFilterFormOutput = z.output<
  typeof ExamCourseAnalysisReportFilterSchema
>;
